@if (widgetWrapper.showProperties) {
  <div class="general-container">
    <div class="text-black text-xs">
      <div class="mt-1 ml-0 mb-1 mr-0">
        {{'widgets.common.max' | translate}}:
        <select [attr.aria-label]="'widgets.common.max' | translate" [(ngModel)]="filterSettings.itemCount">
          <option [value]="5" >5</option>
          <option [value]="10" >10</option>
          <option [value]="15" >15</option>
          <option [value]="20" >20</option>
          <option [value]="50" >50</option>
        </select>
      </div>
      <div >
        {{'widgets.common.include' | translate}}:
        <img src ="assets/icons/icon_info.png" width="15px" height="15px" alt="info"
          pTooltip="{{'widgets.common.tooltip' | translate}}"><br>
          <div>
            @for (entity of filterSettings.fiterEntities; track entity) {
              <label class="w-10rem">
                <input type="checkbox" value="{{entity.id}}"
                  [(ngModel)]="entity.checked"/> {{entity.name}}
                </label>
              }
            </div>
          </div>
        </div>
        <div class="text-center mt-2 mb-3">
          <p-button styleClass="p-button-sm p-0" label="{{'widgets.common.applySettings' | translate}}" (click)="saveSettings()"></p-button>
        </div>
      </div>
    }
    <div #widgetDataContainer id="widgetDataContainer">
      <p-table [value]="rows">
        <ng-template pTemplate="header" let-row>
          <tr>
            <th class="font-bold sticky top-0 w-10rem">{{'widgets.common.entity' | translate}}</th>
            <th class="font-bold sticky top-0">{{'widgets.common.name' | translate}}</th>
            <th class="font-bold sticky top-0 w-7rem">{{'widgets.common.opened' | translate}}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
          <tr class="hover:bg-blue-100 hover:text-white text-black" [ngClass]="rowIndex % 2 === 0 ? 'bg-gray-100' : ''">
            <td>
              <span>{{row.entityType}}</span>
            </td>
            <td>
              @switch (row.entityType) {
                @case (entityName.COMPANY) {
                  <span [pTooltip]="widgetService.getEntityTooltip(row)"
                    [ngClass]="widgetService.getEntityNgClass(entityName.COMPANY)" (click)="widgetService.goToCompany(row.entityId)">
                    {{row.entityName}}
                  </span>
                }
                @case (entityName.SITE) {
                  <span [pTooltip]="widgetService.getEntityTooltip(row)"
                    [ngClass]="widgetService.getEntityNgClass(entityName.SITE)" (click)="widgetService.goToSite(row.entityId)">
                    {{row.entityName}}
                  </span>
                }
                @case (entityName.ASSET_PIPELINE) {
                  <span [pTooltip]="widgetService.getEntityTooltip(row)"
                    [ngClass]="widgetService.getEntityNgClass(entityName.ASSET_PIPELINE)" (click)="widgetService.goToPipeline(row.entityId)">
                    {{row.entityName}}
                  </span>
                }
                @case (entityName.ASSET_TRANSMISSION_LINE) {
                  <span [pTooltip]="widgetService.getEntityTooltip(row)"
                    [ngClass]="widgetService.getEntityNgClass(entityName.ASSET_TRANSMISSION_LINE)" (click)="widgetService.goToTLine(row.entityId)">
                    {{row.entityName}}
                  </span>
                }
                @case (entityName.PLANT) {
                  <span [pTooltip]="widgetService.getEntityTooltip(row)"
                    [ngClass]="widgetService.getEntityNgClass(entityName.PLANT)" (click)="widgetService.goToPlant(row.entityId)">
                    {{row.entityName}}
                  </span>
                }
                @case (entityName.UNIT) {
                  <span [pTooltip]="widgetService.getEntityTooltip(row)"
                    [ngClass]="widgetService.getEntityNgClass(entityName.UNIT)" (click)="widgetService.goToUnit(row.entityId)">
                    {{row.entityName}}
                  </span>
                }
                @case (entityName.TANK) {
                  <span [pTooltip]="widgetService.getEntityTooltip(row)"
                    [ngClass]="widgetService.getEntityNgClass(entityName.TANK)" (click)="widgetService.goToTank(row.entityId)">
                    {{row.entityName}}
                  </span>
                }
                @case (entityName.AREA) {
                  <span [pTooltip]="widgetService.getEntityTooltip(row)"
                    [ngClass]="widgetService.getEntityNgClass(entityName.AREA)" (click)="widgetService.goToArea(row.entityId)">
                    {{row.entityName}}
                  </span>
                }
                @case (entityName.PROJECT_CONFIRMED) {
                  <span [pTooltip]="widgetService.getEntityTooltip(row)"
                    [ngClass]="widgetService.getEntityNgClass(entityName.PROJECT_CONFIRMED)" (click)="widgetService.goToProject(row.entityId, entityName.PROJECT_CONFIRMED)">
                    {{row.entityName}}
                  </span>
                }
                @case (entityName.PROJECT_UNCONFIRMED) {
                  <span [pTooltip]="widgetService.getEntityTooltip(row)"
                    [ngClass]="widgetService.getEntityNgClass(entityName.PROJECT_UNCONFIRMED)" (click)="widgetService.goToProject(row.entityId, entityName.PROJECT_UNCONFIRMED)">
                    {{row.entityName}}
                  </span>
                }
                @case (entityName.TURBINE) {
                  <span [pTooltip]="widgetService.getEntityTooltip(row)"
                    [ngClass]="widgetService.getEntityNgClass(entityName.TURBINE)" (click)="widgetService.goToDrive(row.entityId)">
                    {{row.entityName}}
                  </span>
                }
                @case (entityName.OEQUIPMENT) {
                  <span [pTooltip]="widgetService.getEntityTooltip(row)"
                    [ngClass]="widgetService.getEntityNgClass(entityName.OEQUIPMENT)" (click)="widgetService.goToEquipment(row.entityId)">
                    {{row.entityName}}
                  </span>
                }
                @case (entityName.MEQUIPMENT) {
                  <span [pTooltip]="widgetService.getEntityTooltip(row)"
                    [ngClass]="widgetService.getEntityNgClass(entityName.MEQUIPMENT)" (click)="widgetService.goToMEquipment(row.entityId)">
                    {{row.entityName}}
                  </span>
                }
                @case (entityName.BOILER) {
                  <span [pTooltip]="widgetService.getEntityTooltip(row)"
                    [ngClass]="widgetService.getEntityNgClass(entityName.BOILER)" (click)="widgetService.goToBoiler(row.entityId)">
                    {{row.entityName}}
                  </span>
                }
                @case (entityName.OFFLINE_EVENT) {
                  <span [pTooltip]="widgetService.getEntityTooltip(row)"
                    [ngClass]="widgetService.getEntityNgClass(entityName.OFFLINE_EVENT)" (click)="widgetService.goToOfflineEvent(row.entityId)">
                    {{row.entityName}}
                  </span>
                }
                @case (entityName.PLANT_LTSA) {
                  <span [pTooltip]="widgetService.getEntityTooltip(row)"
                    [ngClass]="widgetService.getEntityNgClass(entityName.PLANT_LTSA)" (click)="widgetService.goToPlantLtsa(row.entityId)">
                    {{row.entityName}}
                  </span>
                }
                @case (entityName.UNIT_LTSA) {
                  <span [pTooltip]="widgetService.getEntityTooltip(row)"
                    [ngClass]="widgetService.getEntityNgClass(entityName.UNIT_LTSA)" (click)="widgetService.goToUnitLtsa(row.entityId)">
                    {{row.entityName}}
                  </span>
                }
                @case (entityName.PIPELINE_LTSA) {
                  <span [pTooltip]="widgetService.getEntityTooltip(row)"
                    [ngClass]="widgetService.getEntityNgClass(entityName.PIPELINE_LTSA)" (click)="widgetService.goToPipelineLtsa(row.entityId)">
                    {{row.entityName}}
                  </span>
                }
                @default {
                  <span pTooltip="{{row.ENTITY_TYPE}} ID: {{row.entityId}}  - {{'common.entityNotAvailable'| translate}}">
                    {{row.entityName}}
                  </span>
                }
              }
            </td>
            <td>
              <span>{{row.date | date:'dd-MMM-y'}}</span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
